// Typelizer digest eb0892ba624cc575ff08514d030bbf50
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /bank_statement_files/:bank_statement_file_id/pdf */
  show: (
    params: { bankStatementFileId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_statement_files/:bank_statement_file_id/pdf', params, options),
    method: 'get',
  }),
}
